var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiRadio from '@material-ui/core/Radio';
import { RadioCheckedIcon } from '../Icon';
/**
 * Kareo wrapped component of the Material-UI Radio. The prop API has been limited to props defined in RadioProps.
 *
 * Radio buttons allow the user to select one option from a set.
 * Use radio buttons when the user needs to see all available options.
 * Radio buttons should have the most commonly used option selected by default.
 * If this is not the case, you can display an error if no value is selected when the form is submitted.
 *
 * Material-UI Radio: [Docs](https://v4.mui.com/components/radio-buttons/), [API](https://v4.mui.com/api/radio/)
 *
 * @storybook: [Radio](http://design.kareoprod.ent/design-system/?path=/story/components-inputs-radio)
 */
var Radio = React.forwardRef(function (_a, ref) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement(MuiRadio, __assign({}, props, { ref: ref, color: "primary", size: size, checkedIcon: React.createElement(RadioCheckedIcon, { fontSize: size === 'small' ? 'smaller' : 'inherit' }), disableFocusRipple: true, disableRipple: true })));
});
Radio.displayName = 'KareoRadio';
export default Radio;
